import React from 'react';
import { makeStyles } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
    svgStyle: {
        width: '5rem',
        height: '5rem',
        // [theme.breakpoints.down('600')]: {
        //     width: '3.6rem',
        //     height: '3.6rem'
        // }
    },
}));

export default function ArrowDiagonalTop(props) {
    const classes = useStyles();

    return (
        <svg className={classes.svgStyle} viewBox="0 0 71.692 67.415">
            <path style={{ fill: props.color }} id="Path_85" data-name="Path 85" d="M897.446,3461.561a4,4,0,0,1-1.179,2.835l-18.616,18.543a3.947,3.947,0,0,1-2.82,1.135,4.05,4.05,0,0,1-2.836-1.247,4.173,4.173,0,0,1,.015-5.8l11.742-11.965H844.687a4,4,0,0,1,0-8h39.065L872.01,3445.6a3.722,3.722,0,0,1-.015-5.422,3.993,3.993,0,0,1,5.656-.015l18.616,18.559A4,4,0,0,1,897.446,3461.561Z" transform="translate(-2447.556 -2529.539) rotate(-30)" />
        </svg>
    )
}